import PropTypes from 'prop-types';
import React from 'react';
import useSeo from '../hooks/use-seo';

/* eslint-disable object-curly-newline, */
const SEO = ({ title, pathname, lang }) => {
  const data = useSeo({
    title,
    pathname,
    lang,
  });
  return (
    <>
      <link
        rel="shortcut icon"
        type="image/png"
        href={data.favicon.childImageSharp.gatsbyImageData.images.fallback.src}
      />
      <title>{data.title}</title>
      {data.title && (
        <>
          <meta property="og:title" content={data.title} />
          <meta name="twitter:title" content={data.title} />
        </>
      )}
      <meta property="og:type" content="website" />
      {data.imageUrl && (
        <>
          <meta name="image" content={data.imageUrl} />
          <meta property="og:image" content={data.imageUrl} />
          <meta name="twitter:image" content={data.imageUrl} />
          <meta name="twitter:card" content="summary_large_image" />
        </>
      )}
      {data.url && <meta property="og:url" content={data.url} />}
      {data.description && (
        <>
          <meta name="description" content={data.description} />
          <meta property="og:description" content={data.description} />
          <meta name="twitter:description" content={data.description} />
        </>
      )}
      {data.article === true && <meta property="og:type" content="article" />}
      {data.twitterUsername && (
        <meta name="twitter:creator" content={data.twitterUsername} />
      )}
    </>
  );
};

export default SEO;

SEO.propTypes = {
  title: PropTypes.string,
  pathname: PropTypes.string,
  lang: PropTypes.string,
};

SEO.defaultProps = {
  title: null,
  pathname: null,
  lang: 'en',
};
